<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'profile'"></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="container">
      <app-error [error]="error"></app-error>
      @if (user && !edit) {
        <div class="row">
          <div class="col-md-6">
            <div class="card mb-3">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="card-title fw-bold">Profile Information</h5>
                  @if (!isImpersonating) {
                    <button class="btn btn-primary" (click)="editProfile()">
                      <span class="material-symbols-outlined">edit_note</span>
                    </button>
                  }
                </div>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'user.email' | translate }}</label>
                  <p>{{user.email}}</p>
                </div>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'user.given_name' | translate }}</label>
                  <p>{{user.given_name}}</p>
                </div>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'user.family_name' | translate }}</label>
                  <p>{{user.family_name}}</p>
                </div>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'user.2fa_devices' | translate }}</h5>
                <div class="list-group mt-3">
                  @if ((otpCredentials?.length || 0) > 0) {
                    @for (device of otpCredentials; track device.credential.id) {
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <p class="mb-0 fw-bold">{{ device.credential.userLabel }}</p>
                          <small class="text-muted"><span>{{ 'job.createdAt' | translate }}</span>: {{ device.credential.createdDate | dateTime }}</small>
                        </div>
                      </div>
                    }
                  } @else {
                    <p class="text-muted">{{ 'user.no_2fa_devices' | translate }}</p>
                  }
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'webauthn_passkey.passkeys' | translate }}</h5>
                <div class="list-group mt-3">
                  @if ((passkeyCredentials?.length || 0) > 0) {
                    @for (passkey of passkeyCredentials; track passkey.credential.id) {
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <p class="mb-0 fw-bold">{{ passkey.credential.userLabel }}</p>
                          <small class="text-muted"><span>{{ 'createdAt' | translate }}</span>: {{ passkey.credential.createdDate | dateTime }}</small>
                        </div>
                      </div>
                    }
                  } @else {
                    <p class="text-muted">{{ 'webauthn_passkey.no_passkeys' | translate }}</p>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">Organization & Role</h5>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'organization' | translate }}</label>
                  @if (user.organization) {
                    <p>{{user.organization.name}}</p>
                  }
                  @if (!user.organization) {
                    <p class="text-muted">{{ 'user.no_organization' | translate }}</p>
                  }
                </div>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'user.roles' | translate }}</label>
                  <p>{{ user.roles | userRoles }}</p>
                </div>
                <div class="form-group mb-3">
                  <label class="fw-bold">{{ 'user.date' | translate }}</label>
                  <p>{{user.created_at | dateTime }}</p>
                </div>
              </div>
            </div>

            @if (canViewOrganizationApiKey()) {
              <div class="card shadow-sm border-0">
                <div class="card-body">
                  <h5 class="card-title fw-bold">{{ 'organizations.api_key' | translate }}</h5>
                  <p class="card-text text-muted">{{ 'organizations.api_key_description' | translate }}</p>
                  <div class="input-group">
                    <div class="form-control bg-light text-dark border-0 text-monospace d-flex align-items-center">
                      <span id="apiKey" class="flex-grow-1">
                        {{ showApiKey ? apiKey : maskedApiKey }}
                      </span>

                      @if (showApiKey && apiKey) {
                        <button class="btn border-0 ms-2" type="button" [disabled]="apiKeyCopied?.success || apiKeyCopied?.error" (click)="copyApiKey()"
                        [ngClass]="{
                          'btn-outline-primary': !apiKeyCopied,
                          'btn-outline-success': apiKeyCopied?.success,
                          'btn-outline-danger': apiKeyCopied?.error
                        }"
                          >
                          <span class="material-icons-outlined">{{ apiKeyCopyIcon }}</span>
                        </button>
                      }

                      <button class="btn btn-outline-primary border-0" type="button" (click)="showApiKey = !showApiKey">
                        <span class="material-icons-outlined">
                          {{ showApiKey ? 'visibility_off' : 'visibility' }}
                        </span>
                      </button>

                      <!-- <button class="btn btn-outline-primary border-0 ms-2" type="button" (click)="rotateApiKey()">
                      <span class="material-icons-outlined">autorenew</span>
                    </button> -->
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
    }
    @if (user && form && edit) {
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-6">
            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'user.personal_information' | translate }}</h5>
                <label class="mt-3">{{ 'user.given_name' | translate }}</label>
                <app-input-with-error [control]="this.form.controls['given_name']"></app-input-with-error>
                <label class="mt-3">{{ 'user.family_name' | translate }}</label>
                <app-input-with-error [control]="this.form.controls['family_name']"></app-input-with-error>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'user.configure_2fa' | translate }}</h5>
                <p class="card-text text-muted">{{ 'user.configure_2fa_info' | translate }}</p>
                <div class="list-group mt-3">
                  @for (device of otpCredentials; track device.credential.id) {
                    <div class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <p class="mb-0 fw-bold">{{ device.credential.userLabel }}</p>
                        <small class="text-muted"><span>{{ 'job.createdAt' | translate }}</span>: {{ device.credential.createdDate | dateTime }}</small>
                      </div>
                      <button class="btn btn-danger" (click)="removeKeycloakCredential(device.credential.id)">
                        <span class="material-icons-outlined">delete</span>
                      </button>
                    </div>
                  }
                </div>
                <div class="mt-3">
                  <button class="btn btn-primary" (click)="add2FADevice()">
                    <span>{{ 'user.configure_2fa_add_button' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'user.change_password_or_mail' | translate }}</h5>
                @if (!verificationCodeRequested) {
                  <div>
                    <p class="card-text text-muted">{{ 'user.change_password_verify' | translate }}</p>
                    <button class="btn btn-primary" (click)="requestVerificationCode()" [ladda]="verificationCodeRequestLoading">
                      <span>{{ 'user.change_password_verify_button' | translate }}</span>
                    </button>
                  </div>
                }
                @if (verificationCodeRequested) {
                  <div>
                    <p class="card-text text-muted">{{ 'user.enter_verification_code_and_password' | translate }}</p>
                    <label>{{ 'user.verification_code' | translate }}</label>
                    <app-input-with-error [control]="this.form.controls['verificationCode']"></app-input-with-error>
                    <label class="mt-3">{{ 'user.new_password' | translate }}</label>
                    <label class="form-text ms-1">(optional)</label>
                    <app-input-with-error [control]="this.form.controls['newPassword']" [type]="'password'"></app-input-with-error>
                    <label>{{ 'user.email' | translate }}</label>
                    <app-input-with-error [control]="this.form.controls['email']"></app-input-with-error>
                  </div>
                }
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title fw-bold">{{ 'webauthn_passkey.configure_passkey' | translate }}</h5>
                <p class="card-text text-muted">{{ 'webauthn_passkey.configure_passkey_info' | translate }}</p>
                <div class="list-group mt-3">
                  @for (passkey of passkeyCredentials; track passkey.credential.id) {
                    <div class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <p class="mb-0 fw-bold">{{ passkey.credential.userLabel }}</p>
                        <small class="text-muted"><span>{{ 'job.createdAt' | translate }}</span>: {{ passkey.credential.createdDate | dateTime }}</small>
                      </div>
                      <button class="btn btn-danger" (click)="removeKeycloakCredential(passkey.credential.id)">
                        <span class="material-icons-outlined">delete</span>
                      </button>
                    </div>
                  }
                </div>
                <div class="mt-3">
                  <button class="btn btn-primary" (click)="addPasskey()">
                    <span>{{ 'webauthn_passkey.configure_passkey_add_button' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <button class="btn btn-outline-primary me-2" (click)="cancelEdit()">{{'cancel' | translate}}</button>
          <button class="btn btn-primary" (click)="saveProfile()">{{'save' | translate}}</button>
        </div>
      </form>
    }
  </div>
</div>
</div>
